/** Placeholder for a profile value the API did not send. */
export const EMPTY_VALUE = "—";

interface ProfileFieldProps {
  readonly label: string;
  readonly value: string;
  readonly mono?: boolean;
}

/** One `<dt>/<dd>` pair of the profile definition list. */
export function ProfileField({ label, value, mono }: ProfileFieldProps) {
  return (
    <div>
      <dt className="font-sans text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </dt>
      <dd
        className={
          mono
            ? "mt-1 font-mono text-xs font-normal text-foreground"
            : "mt-1 font-sans text-sm font-normal text-foreground"
        }
      >
        {value}
      </dd>
    </div>
  );
}
